import React from "react";
import ReactDatePicker from "../../../../components/reactDatePicker/reactDatePicker";
import { actionCreators } from "../redux/membershipBreakdownSaga";
import { useSelector, useDispatch } from "react-redux";
import { useDateFormat } from "../../../../hooks/useDateFormat";

const SingleDatePicker = () => {
  const dispatch = useDispatch();
  const dateFormat = useDateFormat();
  const { date, minDate } = useSelector((state) => state.membershipBreakdown);
  const { calendarEndDate } = useSelector((state) => state.membershipBreakdown.currentUser);

  return (
    <ReactDatePicker
      displayFormat={dateFormat}
      calendarEndDate={calendarEndDate}
      minDate={minDate}
      startDate={date}
      updateDates={(newSelectedDate) => dispatch(actionCreators.updateDate(newSelectedDate))}
    />
  );
};
export default SingleDatePicker;
